(() => {
  function normalize(value) {
    const url = String(value);
    const hashIndex = url.indexOf('#');
    const fragment = hashIndex < 0 ? '' : url.slice(hashIndex);
    const base = hashIndex < 0 ? url : url.slice(0, hashIndex);
    const queryIndex = base.indexOf('?');
    if (queryIndex < 0) return url;

    const parameters = base.slice(queryIndex + 1).split('&');
    if (!parameters.includes('page=1')) return url;

    const query = parameters.filter(parameter => parameter && parameter !== 'page=1').join('&');
    const path = base.slice(0, queryIndex);
    return (query ? `${path}?${query}` : path || window.location.pathname) + fragment;
  }

  function section(value, sectionId) {
    const url = normalize(value).split('#')[0];
    const queryIndex = url.indexOf('?');
    const path = queryIndex < 0 ? url : url.slice(0, queryIndex);
    const parameters = queryIndex < 0 ? [] : url.slice(queryIndex + 1).split('&');
    const query = parameters.filter(parameter => parameter && parameter.split('=')[0] !== 'section_id');
    query.push(`section_id=${encodeURIComponent(sectionId)}`);
    return `${path}?${query.join('&')}`;
  }

  function readCanonical(html) {
    const document = new DOMParser().parseFromString(html, 'text/html');
    return document.querySelector('[data-pagination-canonical]')?.getAttribute('data-pagination-canonical');
  }

  function isCurrentRequest(requestedUrl) {
    const requested = new URL(normalize(requestedUrl), window.location.href);
    const current = new URL(normalize(window.location.href));
    for (const url of [requested, current]) {
      url.searchParams.delete('section_id');
      url.searchParams.delete('sections');
      url.searchParams.sort();
    }
    return requested.origin === current.origin && requested.pathname === current.pathname && requested.search === current.search;
  }

  function updateCanonical(canonical, requestedUrl) {
    if (!canonical || !isCurrentRequest(requestedUrl)) return;
    document.head.querySelector('link[rel="canonical"]')?.setAttribute('href', normalize(canonical));
  }

  function readCollectionState(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const state = parsed.querySelector('[data-collection-description-state]');
    if (!state) return null;
    return {
      schema: JSON.parse(state.textContent),
      slots: Array.from(parsed.querySelectorAll('[data-collection-description-slot]'), marker => {
        const key = marker.getAttribute('data-collection-description-slot');
        const description = marker.nextElementSibling;
        return {
          key,
          html: description?.getAttribute('data-collection-description') === key ? description.outerHTML : ''
        };
      })
    };
  }

  function syncCollection(state, requestedUrl) {
    if (!state || !isCurrentRequest(requestedUrl)) return;
    const markers = Array.from(document.querySelectorAll('[data-collection-description-slot]'));
    for (const slot of state.slots) {
      const marker = markers.find(node => node.getAttribute('data-collection-description-slot') === slot.key);
      if (!marker) continue;
      if (marker.nextElementSibling?.getAttribute('data-collection-description') === slot.key) {
        marker.nextElementSibling.remove();
      }
      if (slot.html) marker.insertAdjacentHTML('afterend', slot.html);
    }

    const descriptionState = document.querySelector('[data-collection-description-state]');
    if (descriptionState) descriptionState.textContent = JSON.stringify(state.schema).replace(/</g, '\\u003c');
    const structuredData = document.querySelector('[data-collection-structured-data]');
    if (structuredData) {
      const data = JSON.parse(structuredData.textContent);
      if (state.schema.page === 1) data.description = state.schema.description;
      else delete data.description;
      structuredData.textContent = JSON.stringify(data).replace(/</g, '\\u003c');
    }
  }

  async function fetchSection(value, sectionId) {
    const main = document.getElementById(`shopify-section-${sectionId}`);
    const collection = window.T4Srequest?.page_type === 'collection' && main?.classList.contains('t4s-section-main');
    const ids = [sectionId];
    if (collection) {
      const heading = document.querySelector('.page_section_heading');
      if (heading?.id.startsWith('shopify-section-')) ids.push(heading.id.slice('shopify-section-'.length));
    }
    try {
      let target = value;
      if (collection) {
        const url = new URL(value, window.location.href);
        url.searchParams.delete('section_id');
        url.searchParams.set('sections', ids.join(','));
        target = url.href;
      }
      const response = await fetch(target, { method: 'GET', headers: { 'Cache-Control': 'no-cache' } });
      if (!response.ok) throw new Error('Section request failed');
      if (!collection) return await response.text();

      const sections = await response.json();
      if (ids.some(id => typeof sections[id] !== 'string' || !sections[id])) throw new Error('Missing collection section');
      const html = ids.map(id => sections[id]).join('\n');
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      if (!parsed.querySelector('[data-ntajax-container]')) throw new Error('Missing collection results');
      if (!readCollectionState(html)) throw new Error('Missing collection description state');
      return html;
    } catch (error) {
      if (collection && isCurrentRequest(value)) window.location.assign(normalize(window.location.href));
      throw error;
    }
  }

  function updateLoadMorePagination(html, controller) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const next = parsed.querySelector('[data-load-more-pagination-footer]');
    const footer = controller.$section[0].querySelector('[data-load-more-pagination-footer]');
    if (!next || !footer) return;
    const page = Number(next.dataset.page);
    const pagination = next.querySelector('.t4s-pagination')?.parentElement;
    const current = footer.querySelector('.t4s-pagination')?.parentElement;
    if (pagination && current) {
      for (const link of pagination.querySelectorAll('a[href]')) {
        const target = Number(new URL(link.href, window.location.href).searchParams.get('page') || 1);
        if (target < controller.loadMoreStart || target > page) continue;
        const label = document.createElement('span');
        label.className = link.className;
        label.classList.remove('link');
        label.setAttribute('aria-disabled', 'true');
        if (link.hasAttribute('aria-label')) label.setAttribute('aria-label', link.getAttribute('aria-label'));
        label.innerHTML = link.innerHTML;
        link.replaceWith(label);
      }
      current.replaceWith(pagination);
    }
    footer.dataset.page = next.dataset.page;
    footer.dataset.status = next.dataset.status;
    const status = controller.$section[0].querySelector('[data-load-more-pagination-status]');
    if (status) status.textContent = next.dataset.status || '';
  }

  window.T4SPaginationURLs = { normalize, section, readCanonical, updateCanonical, readCollectionState, syncCollection, fetchSection, updateLoadMorePagination };
})();
